import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

import {
  formatNumber
} from "../../../utils/format-number.js";

const createCartItemSummaryLayout = (options) => {
  return (
    `<p class="product-item-summary" style="display: none">
      <span class="product-item-summary__quantity">${options.quantity}</span> × <span class="product-item-summary__price">${formatNumber(options.price, 2, `,`, `\u00A0`)}</span> руб.
    </p>`
  );
};

export default class CartItemSummary extends Abstract {
  constructor() {
    super();

    this._quantityElement = null;

    this._options = {};
  }

  getQuantityElement() {
    if (!this._quantityElement) {
      this._quantityElement = this._element.querySelector(`.product-item-summary__quantity`);
    }

    return this._quantityElement;
  }

  setQuantity(quantity) {
    this._options.quantity = quantity;
    this.getQuantityElement().textContent = quantity;
  }

  setElement(element) {
    this._element = element;
  }

  setOptions(options) {
    this._options = Object.assign(
        {},
        options
    );
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  _getTemplate() {
    return createCartItemSummaryLayout(this._options);
  }
}
